import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  text-decoration: none;
  background-color: #d5343d;
  padding: 10px 20px;
  border-radius: 2px;
  color: #fff;
  font-family: 'Lato', sans-serif;
  font-size: 20px;
`;
const StyledButton = styled.button``;

export default function Button({ children, onClick, to }) {
  if (!to && !onClick) return null;
  if (onClick) {
    return <StyledButton onClick={onClick}>{children}</StyledButton>;
  }

  return <StyledLink to={to}>{children}</StyledLink>;
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ pathname: PropTypes.string })
  ])
};

Button.defaultProps = {
  onClick: null,
  to: null
};



// WEBPACK FOOTER //
// ./src/components/Button/Button.js